import { useEffect, useState } from 'react';

export function useAnimatedCounter(initialValue: number) {
  const [counter, setCounter] = useState(initialValue);
  const [prevValue, setPrevValue] = useState(initialValue);
  const [isPulsing, setIsPulsing] = useState(false);
  const [isBlinking, setIsBlinking] = useState(false);
  const duration = 0.5;

  useEffect(() => {
    if (prevValue === null || prevValue === initialValue) return;

    setIsBlinking(false);
    setIsPulsing(true);

    const targetValue = initialValue;
    let startTime: number;

    const updateCounter = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = (timestamp - startTime) / 1000 / duration;

      if (progress < 1) {
        setCounter(Math.round(prevValue + (targetValue - prevValue) * progress));
        requestAnimationFrame(updateCounter);
      } else {
        setCounter(targetValue);
        setIsPulsing(false);
        setIsBlinking(true);
        setPrevValue(targetValue);
      }
    };

    requestAnimationFrame(updateCounter);
  }, [initialValue, prevValue]);

  return { counter, isPulsing, isBlinking };
}
